export const newOrderErrorCode = {
    SUCCESS: 10,
    WRONG_PRICE: 20,
    PROMOTION_NOT_ACTIVE: 30,
    PROMOTION_WRONG_TIME: 40,
    UNAVAILABLE_RESTAURANT: 50,
}